// src/pages/VinculacionList.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Typography } from '@mui/material';
import api from '../api/axiosConfig';

const VinculacionList = () => {
  const { idPoa, idActividad } = useParams();
  const navigate = useNavigate();
  const [partidas, setPartidas] = useState([]);

  useEffect(() => {
    const fetchPartidas = async () => {
      try {
        const res = await api.get(`/poa-partidas/?id_poatres_actividad=${idActividad}`);
        setPartidas(res.data);
      } catch (err) {
        console.error('Error al cargar partidas:', err);
      }
    };
    fetchPartidas();
  }, [idActividad]);

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Vinculación Presupuestaria (Actividad #{idActividad})</Typography>
        <Button
          variant="contained"
          onClick={() => navigate(`/poa/${idPoa}/matriz/${idActividad}/partidas/nuevo`)}
        >
          Nueva Partida
        </Button>
      </Box>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Recurso</TableCell>
              <TableCell>Cantidad</TableCell>
              <TableCell>Unidad</TableCell>
              <TableCell>Precio</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {partidas.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">No hay partidas registradas</TableCell>
              </TableRow>
            ) : (
              partidas.map((partida) => (
                <TableRow key={partida.id_poatres_partida}>
                  <TableCell>{partida.recurso || '—'}</TableCell>
                  <TableCell>{partida.cantidad}</TableCell>
                  <TableCell>{partida.unidad || '—'}</TableCell>
                  <TableCell>{partida.precio}</TableCell>
                  <TableCell>{partida.total}</TableCell>
                  <TableCell><Button
                    size="small"
                    variant="outlined"
                    onClick={(e) => {e.stopPropagation(); window.open(`${process.env.REACT_APP_API_URL}/api/reportes/vinculacion/${idPoa}/`, '_blank')}}
                    
                  >
                    PDF Vinculación
                  </Button></TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default VinculacionList;